import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { FILE_SIZE_LIMITS } from '../constants';

export const ALLOWED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'text/csv': ['.csv'],
  'text/plain': ['.txt'],
};

export const getMaxSizeForType = (fileType) => {
  switch (fileType) {
    case 'application/pdf':
      return FILE_SIZE_LIMITS.PDF;
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.ms-excel':
      return FILE_SIZE_LIMITS.EXCEL;
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return FILE_SIZE_LIMITS.PDF;
    case 'text/csv':
      return FILE_SIZE_LIMITS.CSV;
    case 'text/plain':
      return FILE_SIZE_LIMITS.TXT;
    default:
      return FILE_SIZE_LIMITS.OTHER;
  }
};

export const getFileTypeLabel = (mimeType) => {
  switch (mimeType) {
    case 'application/pdf':
      return 'PDF';
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.ms-excel':
      return 'Excel';
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'Word';
    case 'text/csv':
      return 'CSV';
    case 'text/plain':
      return 'TXT';
    default:
      return 'Unknown';
  }
};

export const getFileIcon = (fileType, className = '') => {
  if (fileType === 'application/pdf') {
    return <PictureAsPdfIcon className={className} />;
  } else if (
    fileType ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    fileType === 'application/vnd.ms-excel' ||
    fileType === 'text/csv'
  ) {
    return <TableChartIcon className={className} />;
  } else if (fileType === 'text/plain') {
    return <TextSnippetIcon className={className} />;
  }
  return <DescriptionIcon className={className} />;
};

export const isFileTypeAllowed = (file) => {
  return Object.keys(ALLOWED_FILE_TYPES).some((type) => {
    return file.type === type;
  });
};

export const createFileObject = (
  rawFile,
  includePreview = false,
  additionalFields = {}
) => {
  const fileObject = {
    id: crypto.randomUUID(),
    rawFile: rawFile,
    file: {
      path: rawFile.name,
      type: rawFile.type,
    },
    ...additionalFields,
  };

  if (includePreview) {
    fileObject.file.preview = URL.createObjectURL(rawFile);
  }

  return fileObject;
};

export const buildDropzoneClassName = (
  baseClassName,
  isDragActive,
  isDragReject,
  additionalClasses = {}
) => {
  let className = baseClassName;

  if (isDragActive) {
    className += ' active';
  }

  if (isDragReject) {
    className += ' file-rejected';
  }

  // Add any additional classes
  Object.entries(additionalClasses).forEach(([condition, classString]) => {
    if (condition === 'true') {
      className += ` ${classString}`;
    }
  });

  return className;
};

// helpers/fileSizeUtils.js
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const calculateTotalSize = (files) => {
  return files.reduce((total, file) => total + file.rawFile.size, 0);
};

export const getFileSizeStatus = (fileSize, maxSize) => {
  const percentage = (fileSize / maxSize) * 100;

  if (fileSize > maxSize) {
    return { status: 'error', percentage };
  } else if (percentage >= 80) {
    return { status: 'warning', percentage };
  } else {
    return { status: 'normal', percentage };
  }
};
